export function getAdminHeaders(extraHeaders: Record<string, string> = {}) {
  const sid = localStorage.getItem("sid") || "";
  return {
    Authorization: sid,
    "x-role-context": "admin",
    "Content-Type": "application/json",
    ...extraHeaders,
  };
}

export function clearAdminSession() {
  localStorage.removeItem("sid");
  localStorage.removeItem("role");
  localStorage.removeItem("account");
  localStorage.removeItem("qc_sid");
  localStorage.removeItem("qc_email");
  localStorage.removeItem("qc_uid");
}
